import request from '@/common/request'
import { AxiosRequestConfig } from 'axios'

const basePath = '/sped-fiscal'

export interface GerarSpedFiscalForm {
	lojaIds: string[]
	dataInicio: string
	dataFim: string
	finalidade?: string
}

/** Inicia a geração assíncrona do SPED Fiscal. Retorna 202; acompanhar em Processos. */
export const gerar = async (form: GerarSpedFiscalForm, config?: AxiosRequestConfig) =>
	request.post(`${basePath}`, form, { ...config })

/** Baixa o resultado já gerado (txt ou zip) como blob. */
export const baixar = async (importacaoId: string, config?: AxiosRequestConfig): Promise<Blob> =>
	request.get(`${basePath}/${importacaoId}/download`, { responseType: 'blob', ...config })
